module.exports = __webpack_public_path__ + "img/jewelleryMain@2x.4c45c8c.jpg";